
import type { Result } from '@empathyco/x-types'
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import { useExplainBrowse } from '../../composables/explain/use-explain-browse'
import ExplainOptimizeMenu from './explain-optimize-menu.component.vue'
import ExplainAsideResultCard from './explain-results-aside-result-card.component.vue'
import ExplainResultsRow from './explain-results-row.component.vue'

export default defineComponent({
  name: 'ExplainResultsHeaderRow',
  components: {
    ExplainResultsRow,
    ExplainAsideResultCard,
    ExplainOptimizeMenu,
  },
  props: {
    results: {
      type: Array as PropType<Array<Result>>,
      required: true,
    },
    query: {
      type: String as PropType<string>,
      required: true,
    },
  },
  setup() {
    const { isBrowseContext } = useExplainBrowse()

    return {
      isBrowseContext,
    }
  },
  computed: {
    resultIds(): string[] {
      return this.results.map((result: Result) => result.id)
    },
  },
})
